import { render, staticRenderFns } from "./member-open-gift.vue?vue&type=template&id=d25df3b4&scoped=true&lang=pug&"
import script from "./member-open-gift.vue?vue&type=script&lang=js&"
export * from "./member-open-gift.vue?vue&type=script&lang=js&"
import style0 from "./member-open-gift.vue?vue&type=style&index=0&id=d25df3b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25df3b4",
  null
  
)

export default component.exports